import React, { useContext, useEffect, useState } from 'react';
import { groupBy } from 'lodash';
import { Link } from 'react-router-dom';
import { Box } from '@hub/box';
import { H2 } from '@hub/heading';
import { LocationDropPinMediumIcon } from '@hub/icon';
import { UnorderedList, ListItem } from '@hub/list';
import { useCentreFilter } from '@scentregroup/shared/hooks/use-filtered-centres';
import { CentresContext, CountryContext } from '@scentregroup/shared/context';
import SuggestedCentres from './suggested-centres';
import CentreLinks from './centre-links';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const NewCentreSelector = _ref => {
  let {
    mode,
    query,
    heading
  } = _ref;
  const centres = useContext(CentresContext);
  const country = useContext(CountryContext);
  const filteredCentres = useCentreFilter(centres)(query);
  const groupedCentres = groupBy(filteredCentres, 'state');
  const paddingLeft = mode === 'search' ? 'spacing-md' : undefined;

  const calculateBoxHeight = () => {
    //88px on line below is equal to the height of the top bar, gap and search bar (48+8+32)
    return "calc(min(1000px, ".concat(document.documentElement.clientHeight - 88, "px))");
  };

  const {
    0: boxHeight,
    1: setBoxHeight
  } = useState(calculateBoxHeight);
  useEffect(() => {
    if (mode !== 'search') {
      return;
    }

    const updateBoxHeight = () => setBoxHeight(calculateBoxHeight);

    window.addEventListener('resize', updateBoxHeight);
    return () => window.removeEventListener('resize', updateBoxHeight);
  }, [mode]);
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      background: 'white',
      maxWidth: mode === 'search' ? '554px' : undefined,
      overflow: mode === 'search' ? 'scroll' : undefined,
      height: boxHeight,
      overscrollBehavior: 'none'
    },
    "data-id": "new-centre-selector_index_NewCentreSelector_Box",
    children: [heading && /*#__PURE__*/_jsx(H2, {
      sx: {
        paddingLeft,
        fontSize: 'font-lg',
        fontWeight: 'bolder',
        paddingTop: 'spacing-md'
      },
      "data-id": "new-centre-selector_index_NewCentreSelector_H2",
      children: heading
    }), /*#__PURE__*/_jsx(SuggestedCentres, {
      mode: mode,
      centres: filteredCentres,
      "data-id": "new-centre-selector_index_NewCentreSelector_Box_SuggestedCentres"
    }), /*#__PURE__*/_jsx(H2, {
      sx: {
        paddingLeft,
        fontSize: 'font-md',
        fontWeight: 'bolder',
        paddingTop: 'spacing-md'
      },
      "data-id": "new-centre-selector_index_NewCentreSelector_Box_H2",
      children: "Country"
    }), /*#__PURE__*/_jsx(UnorderedList, {
      sx: {
        listStyle: 'none',
        margin: 'spacing-none',
        padding: 'spacing-none'
      },
      "data-id": "new-centre-selector_index_NewCentreSelector_Box_UnorderedList",
      children: /*#__PURE__*/_jsx(ListItem, {
        sx: {
          paddingLeft,
          paddingTop: 'spacing-sm',
          '&:hover, &:focus-within': {
            background: 'smoke',
            cursor: 'pointer'
          },
          paddingBottom: 'spacing-sm'
        },
        "data-id": "new-centre-selector_index_NewCentreSelector_UnorderedList_ListItem",
        children: /*#__PURE__*/_jsxs(Link, {
          to: "/",
          style: {
            display: 'flex',
            alignItems: 'center'
          },
          "data-id": "new-centre-selector_index_NewCentreSelector_ListItem_Link",
          children: [/*#__PURE__*/_jsx(LocationDropPinMediumIcon, {
            sx: {
              marginRight: 'spacing-sm'
            },
            boxSize: "size-icon-sm",
            ariaLabel: "location drop pin icon",
            "data-id": "new-centre-selector_index_NewCentreSelector_Link_LocationDropPinMediumIcon"
          }), country]
        })
      }, 'national')
    }), Object.entries(groupedCentres).map((_ref2, index) => {
      let [state, centres] = _ref2;
      return /*#__PURE__*/_jsx(CentreLinks, {
        mode: mode,
        header: state,
        centres: centres,
        "data-id": "new-centre-selector_index_NewCentreSelector_CentreLinks"
      }, "centre-link-".concat(index));
    })]
  });
};

export default NewCentreSelector;